import Http from '../../service';
// deeplink

// 接入微信分享jssdk
export const WeiXinShare = function(shareOption, callback) {
    Http.wxshare()
        .then(data => {
            window.wx.config({
                debug: false,
                appId: data.content.appId,
                timestamp: data.content.timestamp,
                nonceStr: data.content.nonceStr,
                signature: data.content.signature,
                jsApiList: [
                    'onMenuShareAppMessage',

                    'onMenuShareTimeline',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone'
                ]
            });
            if (!shareOption) {
                shareOption = {
                    title: '拍拍贷',
                    desc: '拍拍贷',
                    linkUrl: window.location.href,
                    imgUrl: ''
                };
            }
            if (!callback) {
                callback = function() {};
            }
            window.wx.ready(function() {
                /* 分享到朋友圈 */
                window.wx.onMenuShareTimeline({
                    title: shareOption.title,
                    link: shareOption.linkUrl,
                    imgUrl: shareOption.imgUrl,
                    success: callback,
                    cancel: function() {}
                });

                /* 分享给朋友 */
                window.wx.onMenuShareAppMessage({
                    title: shareOption.title,
                    desc: shareOption.desc,
                    link: shareOption.linkUrl,
                    imgUrl: shareOption.imgUrl,
                    success: callback,
                    cancel: function() {}
                });

                /* 分享到QQ */
                window.wx.onMenuShareQQ({
                    title: shareOption.title,
                    desc: shareOption.desc,
                    link: shareOption.linkUrl,
                    imgUrl: shareOption.imgUrl,
                    success: callback,
                    cancel: function() {}
                });

                /* 分享到腾讯微博 */
                window.wx.onMenuShareWeibo({
                    title: shareOption.title,
                    desc: shareOption.desc,
                    link: shareOption.linkUrl,
                    imgUrl: shareOption.imgUrl,
                    success: callback,
                    cancel: function() {}
                });

                /* 分享到QQ空间 */
                window.wx.onMenuShareQZone({
                    title: shareOption.title,
                    desc: shareOption.desc,
                    link: shareOption.linkUrl,
                    imgUrl: shareOption.imgUrl,
                    success: callback,
                    cancel: function() {}
                });
            });
        })
        .catch(error => {
            console.log('wx', error);
        });
};
export const shareParam = function(param) {
    return {
        wxParam: {
            linkUrl: param.shareUrl,
            title: param.shareTitle,
            desc: param.shareDesc,
            imgUrl: param.shareImgUrl
        },
        appParam: {
            linkURL: param.shareUrl,
            imgURL: param.shareImgUrl,
            title: param.shareTitle,
            desc: param.shareDesc
        }
    };
};